module.exports = __webpack_public_path__ + "media/assets/Prizes-d5cf061e07bb3292d8b98893e595d3bb.svg";